/**
 * Loading Indicator Component
 * Displays a typing animation while waiting for AI response
 */

import React from 'react';
import './LoadingIndicator.css';

interface LoadingIndicatorProps {
  toolName?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  toolName,
}) => {
  return (
    <div className="mcp-loading-indicator">
      <div className="loading-content">
        <div className="typing-indicator">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <span className="loading-text">
          {toolName ? (
            <>
              Koristim <code>{toolName}</code> alat...
            </>
          ) : (
            'AI is thinking...'
          )}
        </span>
      </div>
    </div>
  );
};
